import { render, staticRenderFns } from "./data.vue?vue&type=template&id=7804049d"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"
import style0 from "./data.vue?vue&type=style&index=0&id=7804049d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports